<template>
  <div class="d-flex flex-column align-items-center">
    <div class="app-container col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 border vue-container" :style="cssProps">
      <LoadingOverlay v-if="this.isLoading"/>
      <router-view/>
    </div>
  </div>
</template>
<script>
import LoadingOverlay from "@/views/components/LoadingOverlay";
import {setBrandConfig} from "@/functions/setBrandConfig";
import {mapState, mapMutations} from "vuex";

export default {
  computed: {
    ...mapState(['isLoading', 'brandConfig']),
    cssProps() {
      return {
        backgroundImage: `url(${require(`@/brand/${this.brandConfig.brand}/assets/background.webp`)})`,
      }
    }
  },
  components: {
    LoadingOverlay
  },
  methods: {
    ...mapMutations(['']),
    setFavicon() {
      let manifest = {
        icons: [{
          src: `./img/${this.brandConfig.brand}/icons/favicon-96x96.png`,
          sizes: "192x192",
          type: "image/png"
        }]
      };
      let content = encodeURIComponent(JSON.stringify(manifest));
      let url = "data:application/manifest+json," + content;
      let element = document.createElement('link');
      element.setAttribute('rel', 'manifest');
      element.setAttribute('href', url);
      document.querySelector('head').appendChild(element);
    },
    setTabName() {
      document.title = this.brandConfig.gameTitle;
    },
  },
  beforeMount() {
    setBrandConfig();
    this.setFavicon()
    this.setTabName();
  }
}
</script>
<style lang="scss">
@import "../public/global.scss";

.vue-container {
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}

.vue-container::-webkit-scrollbar {
  display: none;
}
</style>
